import SectionHeading from "./SectionHeading";
import { statBoard } from "@/mocks/mayiBaoliao";

const toneMap: Record<string, string> = {
  secondary: "text-secondary-600",
  primary: "text-primary-600",
  accent: "text-accent-600",
};

const alerts = [
  { time: "15:00–19:00", note: "跨省高速返程高峰，绕城与互通最易缓行。" },
  { time: "12:00–15:00", note: "热门景区客流峰值，入场建议避开这一窗口。" },
  { time: "晚间", note: "美食老街与夜市集中出没，注意随身财物。" },
];

export default function StatsBoard() {
  return (
    <section id="board" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          over="Pulse · 数据小报"
          title="此刻的路况与客流，一眼看懂"
          desc="把分散在快讯里的现场信号，聚成一个可读的数字快照。"
        />

        <div className="mt-9 grid grid-cols-1 gap-4 lg:grid-cols-5">
          {/* 统计快照 */}
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:col-span-3">
            {statBoard.map((s) => (
              <div
                key={s.label}
                className="rounded-lg border border-background-200 bg-background-100/60 p-5"
              >
                <p className="text-sm text-foreground-600">{s.label}</p>
                <p className="mt-2 flex items-baseline gap-1">
                  <span className={`font-heading text-4xl font-black ${toneMap[s.tone]}`}>{s.value}</span>
                  <span className="text-sm text-foreground-500">{s.unit}</span>
                </p>
                <div className="mt-3 flex flex-wrap gap-2 border-t border-background-200 pt-3">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900">
                    {s.trend}
                  </span>
                  <span className="text-xs text-foreground-500">{s.note}</span>
                </div>
              </div>
            ))}
          </div>

          {/* 高峰预警 */}
          <div className="rounded-lg border border-accent-200 bg-accent-100/50 p-5 lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500">
                <i className="ri-time-line text-lg text-background-50" />
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">拥堵时段预警</h3>
            </div>
            <ul className="mt-4 space-y-4">
              {alerts.map((a) => (
                <li key={a.time} className="flex items-start gap-3">
                  <span className="mt-0.5 whitespace-nowrap rounded-md bg-background-50 px-2 py-1 text-xs font-semibold text-accent-700">
                    {a.time}
                  </span>
                  <p className="text-sm leading-relaxed text-foreground-700">{a.note}</p>
                </li>
              ))}
            </ul>
            <p className="mt-5 border-t border-accent-200 pt-3 text-xs leading-relaxed text-foreground-500">
              数据来源于实时路况与现场投稿汇总，仅供参考，出行前请以官方发布为准。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}